import React from 'react'
import styled from 'styled-components'
import { Col, Container } from 'react-bootstrap'
import { Box, LazyImage, MainHeading, SpanStyled } from '../../../ui/Elements'
import { ArrowBtnBrown, Sofa, TransformBg } from '../../../ui/AllImages'
import { useTranslation } from 'react-i18next'
import { ContactButton } from '../../../ui/CustomElements'
import { trackSnapWhatsAppClick, waMessage } from '../../../services/snapPixel'
const Transform = () => {
    const { t } = useTranslation();
    const WhatsApp = () => {
        const phoneNumber = '+966560532519';
        const message = waMessage();
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        trackSnapWhatsAppClick('transform');
        window.open(whatsappURL, '_blank');
    };
    return (
        <>
            <TransformWapper className='container-fluid common-space transformFluid'>
                <Container>
                    <Box className='transformRow row'>
                        <Col md={12} className="transformColMain">
                            <Box className='transformContent'>
                                
                                <MainHeading className='main-heading mb-1' size="" color="var(--bg2)">
                                    {t('transformSpaces')}
                                </MainHeading>
                                <SpanStyled className='d-flex mb-3 transformTxt' color='var(--bg2)' size="24px">
                                    {t('transformTxt')}
                                </SpanStyled>
                                <SpanStyled className='d-flex mb-2'>
                                    <ContactButton icon={ArrowBtnBrown} bg="var(--bg2)" label={t('ContactUs')} color='var(--themeColor)' onClick={WhatsApp} />
                                </SpanStyled>
                                <Box className='sofaBox'>
                                    <LazyImage src={Sofa} />
                                </Box>
                                

                            </Box>
                            

                        </Col>
                        
                    </Box>
                </Container>
            </TransformWapper>
        </>
    )
}
const TransformWapper = styled.section`
    padding-bottom: 0;
    padding-top: 0;
    
    & > .container{
        .transformRow{
            margin-left: 0;
            margin-right: 0;
        }
        .transformColMain{
            position: relative;
            display: flex;
            align-items: center;
            height: 353px;
            background-image: url(${TransformBg});
            background-repeat: no-repeat;
            background-size: cover;
            background-position: left center;
            border-radius: 16px;
            overflow: hidden;
            .transformContent{
                display: flex;
                width: 720px;
                flex-wrap: wrap;
                flex-direction: column;
                padding-left: 165px;
                
            }
            .sofaBox{
                position: absolute;
                right: 90px;
                top: 10px;
            }
        }
        
    }
    body.rtl &{
        & > .container{
            .transformColMain{
                .transformContent{
                    padding-right: 165px;
                }
                .sofaBox{
                    right: auto;
                    left: 90px;
                    img{
                        -webkit-transform: scaleX(-1) !important;
                        -moz-transform: scaleX(-1) !important;
                        -o-transform: scaleX(-1) !important;
                        transform: scaleX(-1) !important;
                    }
                }
            }
            
        }
    }
    
    @media (max-width: 1399px) {
        
    }
    @media (max-width: 1299px) {
        & > .container{
            .transformColMain{
                .transformContent{
                    width: 620px;
                    padding-left: 50px;
                }
                .sofaBox{
                    right: 0px;
                }
            }
            
        }
        body.rtl &{
            & > .container{
                .transformColMain{
                    .transformContent{
                        padding-right: 50px;
                    }
                    .sofaBox{
                        right: auto;
                        left: 0px;
                        
                    }
                }
                
            }
        }
    }
    @media (max-width: 1199px) {
        & > .container{
            .transformColMain{
                .transformContent{
                    width: 620px;
                    padding-left: 50px;
                }
                .sofaBox{
                    right: -70px;
                }
            }
            
        }
        body.rtl &{
            & > .container{
                .transformColMain{
                    .transformContent{
                        padding-left: 0px;
                        padding-right: 50px;
                    }
                    .sofaBox{
                        right: auto;
                        left: -70px;
                        
                    }
                }
                
            }
        }
    }
    @media (max-width: 991px) {
        & > .container{
            .transformColMain{
                .transformContent{
                    width: 620px;
                    padding-left: 50px;
                }
                .sofaBox{
                    display: none;
                }
            }
            
        }
    }
    @media (max-width: 767px) {
        & > .container{
            .transformColMain{
                height: auto;
                padding-top: 50px;
                padding-bottom: 50px;
                .transformContent{
                    width: 100%;
                    padding-left: 5px;
                    padding-right: 5px;
                    .transformTxt{
                        font-size: 18px;
                    }
                }
                
            }
            
        }
        body.rtl &{
            & > .container{
                .transformColMain{
                    .transformContent{
                        padding-left: 5px;
                        padding-right: 5px;
                    }
                    
                }
                
            }
        }
    }
    @media (max-width: 640px) {
       
    }
    @media (max-width: 575px) {
        
    }
    @media (max-width: 350px) {
        
    }
`
export default Transform
